import React from 'react';
import { useLocation } from 'react-router';

interface FunnelContainerProps {
  className?: string;
  children: React.ReactNode;
}

const FunnelContainer: React.FC<FunnelContainerProps> = ({ className = '', children }) => {
  const location = useLocation();
  const isInterstitialPage = location.pathname.startsWith('/interstitial');

  return (
    <div
      className={`
        flex flex-1 flex-col w-full max-w-full
        ${
          isInterstitialPage
            ? 'h-full'
            : 'px-6 tablet:px-0 pb-32 tablet:pb-[80px] tablet:w-[560px] tablet:self-center mx-auto flex-1'
        }
        ${className}
      `}
    >
      {children}
    </div>
  );
};

export default FunnelContainer;
